import React from 'react'

import { Row } from 'Components/UI'

import ClutchChampionBadgeGlyph from 'Assets/Svg/clutchChampionBadge.svg'
import ClutchGlobalBadgeGlyph from 'Assets/Svg/clutchGlobalBadge.svg'

import { SCRIPTS } from './constants'
import { Container, IFrameHolder } from './styles'

function ClutchBadges() {
  return (
    <Container>
      {SCRIPTS.map(item => (
        <IFrameHolder key={item.id}>
          {/* Four third-party documents from shareables.clutch.co, each with
              its own cookies and assets. They sit mid-page, so loading them
              eagerly put ~2.4 s of third-party latency (8 s on a bad day) in
              front of /agency's first paint. */}
          <iframe loading="lazy" src={item.src} title={item.title} />
        </IFrameHolder>
      ))}

      <Row gap={4}>
        {ClutchChampionBadgeGlyph()}

        {ClutchGlobalBadgeGlyph()}
      </Row>
    </Container>
  )
}

export default ClutchBadges
